import { render, staticRenderFns } from "./wareProduct.vue?vue&type=template&id=61efb0f0&scoped=true&"
import script from "./wareProduct.vue?vue&type=script&lang=js&"
export * from "./wareProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61efb0f0",
  null
  
)

export default component.exports